
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Marcus Rivera',
    title: 'Office Manager',
    company: 'Tri-State Logistics',
    location: 'Edison, NJ',
    rating: 5,
    text: 'We had Simple Amenities install a cooler in our break room and honestly it\'s been a game changer. Our team loves it, and the best part? We haven\'t paid a single dollar. They stock it, they maintain it — we just enjoy it.',
    avatar: 'https://public.readdy.ai/ai/img_res/a6c003972785e03db579399243821070.jpg',
  },
  {
    id: 2,
    name: 'Sandra Kowalski',
    title: 'HR Director',
    company: 'Pinnacle Medical Staffing',
    location: 'Woodbridge, NJ',
    rating: 5,
    text: 'I was skeptical at first — free always sounds too good to be true. But Simple Amenities delivered exactly what they promised. The machine is always stocked, never broken, and our employees are thrilled. Highly recommend to any NJ business.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20polish%20american%20woman%20HR%20director%20in%20her%2050s%2C%20confident%20smile%2C%20blazer%2C%20clean%20light%20background%2C%20natural%20lighting%2C%20realistic%20portrait%20photography&width=80&height=80&seq=t2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Darnell Thompson',
    title: 'Facilities Director',
    company: 'Atlantic Auto Group',
    location: 'Freehold, NJ',
    rating: 5,
    text: 'We manage a large dealership with over 80 employees. Simple Amenities set us up with two coolers and the service has been flawless. They come in regularly to restock and we\'ve never had to call about a maintenance issue. Zero cost to us.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20black%20male%20facilities%20director%20in%20his%2040s%2C%20friendly%20expression%2C%20polo%20shirt%2C%20clean%20office%20background%2C%20natural%20lighting%2C%20realistic%20portrait%20photography&width=80&height=80&seq=t3&orientation=squarish',
  },
  {
    id: 4,
    name: 'Jennifer Patel',
    title: 'Owner',
    company: 'Patel Family Chiropractic',
    location: 'Matawan, NJ',
    rating: 5,
    text: 'As a small business owner, every dollar counts. Having a fully stocked cooler in our waiting room at absolutely no cost has been incredible. Patients love it and it adds a professional touch to our practice. Simple Amenities is the real deal.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20indian%20american%20woman%20small%20business%20owner%20in%20her%2030s%2C%20warm%20smile%2C%20professional%20attire%2C%20clean%20light%20background%2C%20natural%20lighting%2C%20realistic%20portrait%20photography&width=80&height=80&seq=t4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Tom Gallagher',
    title: 'Plant Manager',
    company: 'Garden State Packaging',
    location: 'Perth Amboy, NJ',
    rating: 5,
    text: 'Our warehouse crew works hard and having cold drinks available at no cost to the company is a huge morale boost. Simple Amenities handles everything — delivery, restocking, repairs. We\'ve had zero headaches since day one.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20irish%20american%20male%20plant%20manager%20in%20his%2050s%2C%20no-nonsense%20friendly%20expression%2C%20safety%20vest%20over%20shirt%2C%20industrial%20background%20blurred%2C%20natural%20lighting%2C%20realistic%20portrait%20photography&width=80&height=80&seq=t5&orientation=squarish',
  },
  {
    id: 6,
    name: 'Alicia Moreno',
    title: 'Office Administrator',
    company: 'Coastal Realty Group',
    location: 'Red Bank, NJ',
    rating: 5,
    text: 'We\'ve tried other vending companies before and always ended up dealing with broken machines and billing headaches. Simple Amenities is completely different — no invoices, no repairs, no complaints. Just a stocked cooler every time we look.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20hispanic%20woman%20office%20administrator%20in%20her%2030s%2C%20bright%20smile%2C%20business%20casual%2C%20clean%20modern%20office%20background%2C%20natural%20lighting%2C%20realistic%20portrait%20photography&width=80&height=80&seq=t6&orientation=squarish',
  },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const visibleCount = 3;

  const handlePrev = () => {
    setActiveIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => Math.min(testimonials.length - visibleCount, prev + 1));
  };

  const visible = testimonials.slice(activeIndex, activeIndex + visibleCount);

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Real Reviews
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Trusted by New Jersey Businesses
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Don't take our word for it — hear from business owners across NJ who are already enjoying free, fully maintained coolers.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="flex flex-wrap justify-center gap-10 mb-16">
          <div className="text-center">
            <p className="text-4xl font-bold text-teal-600">100%</p>
            <p className="text-sm text-gray-500 mt-1">Free to Businesses</p>
          </div>
          <div className="w-px bg-gray-200 hidden md:block"></div>
          <div className="text-center">
            <p className="text-4xl font-bold text-teal-600">5★</p>
            <p className="text-sm text-gray-500 mt-1">Average Rating</p>
          </div>
          <div className="w-px bg-gray-200 hidden md:block"></div>
          <div className="text-center">
            <p className="text-4xl font-bold text-teal-600">50+</p>
            <p className="text-sm text-gray-500 mt-1">NJ Locations Served</p>
          </div>
          <div className="w-px bg-gray-200 hidden md:block"></div>
          <div className="text-center">
            <p className="text-4xl font-bold text-teal-600">$0</p>
            <p className="text-sm text-gray-500 mt-1">Cost to You, Ever</p>
          </div>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-10">
          {visible.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col gap-5 hover:shadow-md transition-shadow"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-base"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.title}, {t.company}</p>
                  <p className="text-xs text-teal-600 font-medium mt-0.5">
                    <i className="ri-map-pin-2-line mr-1"></i>{t.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex justify-center items-center gap-4">
          <button
            onClick={handlePrev}
            disabled={activeIndex === 0}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:border-teal-500 hover:text-teal-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div className="flex gap-2">
            {Array.from({ length: testimonials.length - visibleCount + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === activeIndex ? 'bg-teal-600 w-6' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>

          <button
            onClick={handleNext}
            disabled={activeIndex >= testimonials.length - visibleCount}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:border-teal-500 hover:text-teal-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
